<template>
  <div class="dev-envs-container p-3">
    <LoadingState v-if="isLoading()" :size="50" />
    <ErrorState v-else-if="isErrored()" />
    <template v-else-if="site && devSites">
      <DevEnvironmentsTypeList
        :plan="plan"
        :site="site"
        :sites="getDevSites()"
        type="development"
        @hide="$emit('hide')"
      />
      <template v-if="!plan.isTShirt">
        <hr />
        <DevEnvironmentsTypeList
          :plan="plan"
          :site="site"
          :sites="getStagingSites()"
          type="staging"
          @hide="$emit('hide')"
        />
      </template>
    </template>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import DevEnvironmentsTypeList from "@/pages/Dashboard/Plans/Plan/Site/DevEnvironmentsTypeList";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import store from "@/store";

export default {
  name: "DevEnvironmentsList",
  components: {
    DevEnvironmentsTypeList,
    ErrorState,
    LoadingState,
  },
  props: {
    siteId: Number,
  },
  setup(props) {
    const plan = computed(() => store.getters["plans/getItem"]);
    const site = computed(() => store.getters["sites/getItem"]);
    const siteStatus = computed(() => store.getters["sites/getItemStatus"]);
    const devSites = computed(() => store.getters["devSites/getList"]);
    const devSitesStatus = computed(() => store.getters["devSites/getListStatus"]);

    const getDevSites = () =>
      devSites.value?.filter((item) => item.environmentType === "development");
    const getRouterLink = (site) => {
      return {
        name: "plan-site-dev-detail",
        params: {
          planId: plan.value.id,
          siteId: props.siteId,
          devSiteId: site.id,
        },
      };
    };
    const getStagingSites = () =>
      devSites.value?.filter((item) => item.environmentType === "staging");

    const isErrored = () => siteStatus.value.isErrored || devSitesStatus.value.isErrored;
    const isLoading = () => siteStatus.value.isLoading || devSitesStatus.value.isLoading;

    onMounted(() => {
      store.dispatch("devSites/getList", props.siteId);
      store.dispatch("sites/get", props.siteId);
    });

    return {
      plan,
      site,
      devSites,
      devSitesStatus,
      getDevSites,
      getRouterLink,
      getStagingSites,
      isErrored,
      isLoading,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.loader {
  height: 55vh;
}
.dev-envs-container {
  min-width: 330px;
}
</style>
